<template>
  <div>
    <div class="air__utils__heading">
      <div class="row">
        <div class="col-4 col-sm-6">
          <h5>Attendance Detail Report</h5>
        </div>
<!--        <div class="col-8 col-sm-6 text-right">
          <span>
            <a-button v-if="exportCompleted" :href="downloadUrl" target="_blank"
            type="primary"
            >
              Download Report
            </a-button>
          </span>
          <span style="margin-left: 10px;">
            <a v-if="pagepermission.viewable"
            class="btn btn-with-addon"
            style="background-color: #107c41; color: #fff;"
            :loading="loading"
            @click="handleExport"
            :disabled="!getAttendanceCalled"
            >
            <span class="btn-addon">
              <i class="btn-addon-icon fe fe-download" />
            </span>
              Export
            </a>
          </span>
        </div>-->
      </div>
    </div>
    <div class="row justify-content-center" v-if="pagepermission.viewable">
      <div class="col-xl-12">
        <div class="row mb-2">
          <!-- Session -->
          <div class="col-md-2 col-12 mb-2">
            <a-select
              size="large"
              v-model="selectedSession"
              optionFilterProp="children"
              style="width: 100%"
              @change="handleSessionChange"
              :filterOption="false"
              :defaultValue="currentSession ? currentSession.id : ''"
            >
            <template v-for="schoolSession in schoolSessions">
              <a-select-option :value="schoolSession.id" :key="schoolSession.id">
                  {{schoolSession.name}}
                  <small class="text-primary ml-2">{{ currentSession.id === schoolSession.id ? 'Current' : '' }}</small>
              </a-select-option>
            </template>
            </a-select>
          </div>

          <!-- Class -->
          <div class="col-md-2 col-12 mb-2">
            <a-spin :spinning="classSpinning">
              <a-select
                size="large"
                v-model="selectedClass"
                placeholder="Select class"
                optionFilterProp="children"
                style="width: 100%"
                @change="handleClassChange"
                :filterOption="false"
                :defaultValue="undefined"
              >
                <a-select-option :value="undefined">All Classes</a-select-option>
                <template v-for="schoolClass in schoolClasses">
                  <a-select-option :value="schoolClass.id" :key="schoolClass.id">
                  {{schoolClass.name}}
                  </a-select-option>
                </template>
              </a-select>
            </a-spin>
          </div>
          <!-- Section -->
          <div class="col-md-2 col-12 mb-2">
            <a-spin :spinning="sectionSpinning">
              <a-select
                size="large"
                v-model="selectedSection"
                placeholder="All Section"
                optionFilterProp="children"
                style="width: 100%"
                @change="handleSectionChange"
                :filterOption="false"
                :defaultValue="undefined"
                :disabled="!selectedClass"
              >
                <a-select-option :value="undefined">All Sections</a-select-option>
                <template v-for="section in sections">
                  <a-select-option :value="section.id" :key="section.id">
                  {{section.name}}
                  </a-select-option>
                </template>
              </a-select>
            </a-spin>
          </div>

          <!-- Student Search -->
          <div class="col-md-3 col-12 mb-2">
            <a-input-search
              size="large"
              v-model="search"
              placeholder="Enter student name or code"
              style="width: 100%"
              @search="studentSearch"
            />
          </div>
          <!-- Date -->
          <div class="col-md-3 mb-2">
            <a-date-picker
              size="large"
              v-model="selectedDate"
              style="width: 100%"
              @change="handleDateSelect"
            ></a-date-picker>
          </div>
        </div>
        <div class="Card">
          <div class="card-body">
           <attendance-summary-card :overallData="overallData" />
          </div>
        </div>
        <div class="card">
          <div class="card-body">
            <a-spin :spinning="loading">
              <attendance-detail-report-table
                :enrollAttendanceData="data"
                :attendanceDate="moment(selectedDate).format('YYYY-MM-DD')"
                :additionalData="makeAdditionalData()"
                @submitted="handleAttendanceSubmitted"
                :rolesetting="pagepermission"
              />
            </a-spin>
          </div>
        </div>
        <div class="text-right">
          <a-pagination
            showSizeChanger
            @showSizeChange="onShowSizeChange"
            :total="meta.total"
            :pageSize.sync="pageSize"
            v-model="current"
            @change="onChange"
          >
            </a-pagination>
        </div>
      </div>
    </div>
    <div class="row justify-content-center" v-else>
      <p class="error">
        You don't have permission to use this feature.
      </p>
    </div>
  </div>
</template>
<style scoped>
  /* Use ::v-deep to target deeply nested Ant Design styles */
  ::v-deep .ant-input-lg {
    padding: 7px 13px !important;
  }
</style>
<script>
import AttendanceDetailReportTable from '@/components/attendancedetailreport/Table/index'
import AttendanceSummaryCard from '@/components/Attendancesummary/index.vue'
import { find } from 'lodash'
import moment from 'moment'
// import ref from 'vue'

export default {
  components: {
    AttendanceDetailReportTable,
    AttendanceSummaryCard,
  },
  beforeMount: function() {
    let rc = this.$roleutility.checkpermission('attendance', 22)
    rc.then(data => {
      console.log(data)
      this.pagepermission = data.pagePermission
    })
  },
  mounted: function() {
    this.$http.get('/api/session')
      .then(({ data }) => {
        this.schoolSessions = data.data
        this.selectedSession = find(data.data, ['is_current', 1]).id
      })
      .catch(error => {
        console.log(error)
      })
    this.$http.get('/api/class')
      .then(({ data }) => {
        this.schoolClasses = data.data
      })
      .catch(error => {
        console.log(error)
      })
  },
  computed: {
    currentSession: function() {
      const session = find(this.schoolSessions, ['is_current', 1])
      return session
    },
    currentStyle() {
      return this.holidays ? (current) => {
        const style = {}
        // Check for Holiday (excluding Sundays)
        if (this.data.holidays.some(holiday => holiday.isSame(current, 'day'))) {
          if (current.day() !== 0) { // Exclude Sundays
            style.backgroundColor = '#f0f0f0' // Example holiday style
          }
        }
        return style
      } : null
    },
  },
  watch: {
    currentSession: function (val) {
      this.selectedSession = val.id
    },
  },
  data: function() {
    return {
      search: '',
      getAttendanceCalled: false,
      exportCompleted: false,
      downloadUrl: '',
      loading: false,
      visible: false,
      dateFormat: 'DD-MM-YYYY',
      data: null,
      overallData: {},
      meta: {},
      current: 1,
      pageSize: 30,
      schoolClasses: [],
      sections: [],
      schoolSessions: [],
      selectedClass: undefined,
      selectedSection: undefined,
      selectedSession: undefined,
      selectedDate: moment(),
      sectionSpinning: false,
      classSpinning: false,
      disabledDates: [],
      pagepermission: {
        insertable: false,
        editable: false,
        viewable: false,
        deletable: false,
      },
    }
  },
  methods: {
    moment,
    getAttendanceData: function(value) {
      if (this.selectedDate) {
        this.disabledDates = []
        this.loading = true

        let page = this.current
        if (value) {
          page = 1
          this.current = 1
        }

        this.$http.get('/api/attendance/detail-report', {
          params: {
            search: this.search,
            class_id: this.selectedClass,
            section_id: this.selectedSection,
            session_id: this.selectedSession,
            start_date: moment(this.selectedDate).format('YYYY-MM-DD'), // '2021-11-01'
            // endDate: moment(this.selectedDate[1]).format('YYYY-MM-DD'), // '2021-11-30'
            // date: moment(this.selectedDate).format('YYYY-MM-DD'),
            report_type: 'DAILY',
            limit: this.pageSize,
            page: page,
          },
        }).then(({ data }) => {
          this.loading = false
          console.log('Data', data)
          this.overallData = data.data.overall_attendance
          this.data = data.data['enrollment_with attendance'].data
          this.meta = {
            current_page: data.data['enrollment_with attendance'].current_page,
            total: data.data['enrollment_with attendance'].total,
            last_page: data.data['enrollment_with attendance'].last_page,
            from: data.data['enrollment_with attendance'].from,
            to: data.data['enrollment_with attendance'].to,
            per_page: data.data['enrollment_with attendance'].per_page,
            path: data.data['enrollment_with attendance'].path,
          }
          this.getAttendanceCalled = true // Enable export button only when data available
        })
      } else {
        this.$message.warning('You need to select a date to view attendance!')
        this.data = null
      }
    },
    /* handleExport() {
      this.loading = true
      this.$http
        .get('/api/attendance/report/export', {
          responseType: 'arraybuffer',
          params: {
            studentName: this.studentName,
            class_id: this.selectedClass,
            section_id: this.selectedSection,
            session_id: this.selectedSession,
            startDate: moment(this.selectedDate[0]).format('YYYY-MM-DD'), // '2021-11-01'
            endDate: moment(this.selectedDate[1]).format('YYYY-MM-DD'), // '2021-11-30'
            // date: moment(this.selectedDate).format('YYYY-MM-DD'),
          },
        })
        .then(({ data }) => {
          // let blob = new Blob([data], {
          //   type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          // })
          this.loading = false
          this.$notification['info']({
            message: 'Student attendance export started!',
            description: `Student attendance export is in progress. This will take just a few moments. Your file will be available in the Downloads menu once complete.`,
          })

          // let link = document.createElement('a')
          // link.href = window.URL.createObjectURL(blob)
          // link.download = 'StudentAttendaceExport.xlsx'
          // link.click()
          // this.pollExportStatus() // Start polling
        })
        .catch((error) => {
          this.loading = false
          this.$neoNotify.error(error)
        })
    }, */
    makeAdditionalData() {
      return {
        classId: this.selectedClass,
        sectionId: this.selectedSection,
        sessionId: this.selectedSession,
      }
    },
    getClasses: function() {
      this.classSpinning = true
      this.$http.get('/api/class', {
        params: {
          session_id: this.selectedSession,
        },
      })
        .then(({ data }) => {
          this.schoolClasses = data.data
          console.log(data.data)
          this.classSpinning = false
        })
        .catch(error => {
          console.log(error)
        })
    },
    studentSearch(value) {
      this.search = value
      this.getAttendanceData(true)
    },
    handleClassChange (value) {
      this.selectedSection = undefined
      this.data = null
      if (value) {
        this.selectedClass = value
        this.getAttendanceData()
        this.sectionSpinning = true
        this.getClassSections(value)
      } else {
        this.getAttendanceCalled = false
      }
    },
    getClassSections(value) {
      this.$http.get(`/api/section/class/${value}`)
        .then(({ data }) => {
          this.sections = data.data
          this.sectionSpinning = false
        })
        .catch(error => {
          console.log(error)
        })
    },
    handleSectionChange (value) {
      if (value) {
        this.selectedSection = value
        this.getAttendanceData()
      } else {
        this.selectedSection = undefined
        this.getAttendanceData()
      }
    },
    handleSessionChange (value) {
      if (value) {
        this.selectedSession = value
      } else {
        this.selectedSession = this.currentSession
      }

      this.selectedClass = undefined
      this.selectedSection = undefined
      this.getClasses()
    },
    handleDateSelect (date) {
      this.selectedDate = date
      this.getAttendanceData()
    },
    disabledDate(current) {
      return this.disabledDates.includes(current.format('YYYY-MM-DD')) || current.day() === 0 || current > moment().endOf('day')
    },
    handleAttendanceSubmitted() {
      this.selectedDate = moment()
      this.getAttendanceData()
    },
    onShowSizeChange(current, pageSize) {
      this.pageSize = pageSize
      this.current = current
      this.getAttendanceData()
    },
    onChange(current) {
      this.current = current
      this.getAttendanceData()
    },
  },
}
</script>
